const layout = {
  sideBar: {
    menu: {
      jobs: {
        title: 'Orders',
        children: {
          jobs: 'Orders',
        },
      },
    },
  },
};

export default layout;
